import { initReveals } from './ui/reveals'
import { initConversion } from './ui/conversion'
import { initCalModal } from './ui/calmodal'
import { initMenu } from './ui/menu'
import { captureGclid } from './analytics/gclid'

// Marca que hay JS: recién entonces el CSS oculta los .reveal.
// Sin JS, el sitio completo es visible y funcional (principio rector).
document.documentElement.classList.add('js')

captureGclid()
initReveals()
initConversion()
initMenu() // antes del CalModal: su CTA inyectado también debe interceptarse
initCalModal()

// La Máquina (chunk 3D) despierta solo si el dispositivo la merece.
const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches
const forcedTier = new URLSearchParams(location.search).get('tier')
const wantsStatic = reducedMotion || forcedTier === 'static'

if (!wantsStatic && supportsWebGL2()) {
  let booted = false
  const boot = () => {
    if (booted) return
    booted = true
    const t0 = performance.now()
    import('./app/App')
      .then(({ App }) => App.mount(t0))
      .catch((err) => console.error('[máquina] no despertó:', err))
  }

  if (matchMedia('(pointer: coarse)').matches) {
    // Mobile: la Máquina despierta con la PRIMERA interacción — el boot
    // pesado (three + shaders) nunca compite con la carga del contenido.
    for (const ev of ['scroll', 'touchstart', 'pointerdown'] as const) {
      addEventListener(ev, boot, { once: true, passive: true })
    }
    setTimeout(boot, 6000) // y si nadie toca nada, despierta sola
  } else {
    'requestIdleCallback' in window ? requestIdleCallback(boot, { timeout: 2500 }) : setTimeout(boot, 350)
  }
}

function supportsWebGL2(): boolean {
  try {
    const gl = document.createElement('canvas').getContext('webgl2')
    if (!gl) return false
    // La sim FBO necesita render a float — sin esto, tier STATIC.
    return gl.getExtension('EXT_color_buffer_float') !== null
  } catch {
    return false
  }
}
